import * as api from 'app/shared/api';
import { PageLoadedData, Action } from 'app/pages/DiscountsList/actionTypes';
import { Dispatch } from 'redux';
import { pageLoaded } from 'app/pages/DiscountsList/actions';
import { DiscountListItemDto } from 'app/shared/model/DiscountListItemDto';
import { getSelectedDivisionId } from 'app/pages/AgentPricing/utils/division';
import { QueryParamsMap } from 'app/RouteDefinition';
import { DiscountListFilters } from 'app/shared/api/getDiscountList';

type DiscountListAndData = {
    discounts: DiscountListItemDto[],
    data: PageLoadedData
}

export function loadPage(dispatch: Dispatch<Action>, _queryParams?: QueryParamsMap, filters?: DiscountListFilters): Promise<void> {
    const divisionId = getSelectedDivisionId();
    return fetchServerData(divisionId, filters)
        .then(lookupAgents)
        .then(x => {
            dispatch(pageLoaded(x.discounts, x.data));
        })
}

function lookupAgents(discountListAndData: DiscountListAndData) : Promise<DiscountListAndData> {
    const discounts = discountListAndData.discounts;
    const data = discountListAndData.data;

    const agentIds : string[] = []; 
    discountListAndData.discounts.forEach(x =>{
        agentIds.push(...x.agentIds);
    }); 
    const uniqueAgentIds = agentIds.filter(
        (v, i, a) => a.indexOf(v) === i); 

    const agents = uniqueAgentIds.length > 0 
        ? api.getAgentsById(false, ... uniqueAgentIds)
        : Promise.resolve([]);

    return Promise.resolve(agents).then((results) => {
        data.agents = results;
        return {
            discounts,
            data
        }
    });
}

function fetchServerData(divisionId?: number, filters?: DiscountListFilters): Promise<DiscountListAndData> {
    const discountList = api.getDiscountList(divisionId, filters);
    const schools = api.getAllSchools();
    const countries = api.getAllCountries();
    
    return Promise.all([discountList, schools, countries]) 
        .then(serverData => {
            const discounts = serverData[0];
            const data : PageLoadedData = {
                schools: serverData[1],
                countries: serverData[2],
                agents: []
            }
            return {discounts, data};
        });
}